<template>
  <div>
      <Tool>
        <template v-slot:title>
          <h1 class="tool-title-h1">
            权限管理
          </h1>
        </template>
      </Tool>
      <div class="content">
        <div style="margin-bottom: 16px; display: flex; align-items: center;">
          <a-button type="primary" icon="plus-circle" ghost @click="handleAdd">新增</a-button>
        </div>

        <a-table rowKey="id" :loading="loading" :columns="columns" :data-source="data" :pagination="false" bordered>

          <template slot="icon" slot-scope="icon">
            <a-icon :type="icon"/>
          </template>

          <template slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)">编辑</a>
            <a-divider type="vertical"/>
            <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
              <a>删除</a>
            </a-popconfirm>
          </template>

        </a-table>
      </div>

      <PermissionCreateModal ref="permissionCreateModal" @ok="loadData"></PermissionCreateModal>

  </div>
</template>

<script>

import Tool from '@/components/Tool.vue'
import PermissionCreateModal from "../components/setting/PermissionCreateModal";
import {HttpMixins} from "@/mixins/http-mixins";

export default {
  name: "Permission",
  components: {
    PermissionCreateModal,
    Tool
  },
  mixins: [HttpMixins],
  data() {
    return {
      data: [],
      loading: false,
      columns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: 'URL',
          dataIndex: 'url',
          width: '15%',
        },
        {
          title: '组件',
          dataIndex: 'component',
          width: '15%',
        },
        {
          title: '排序',
          dataIndex: 'sort',
          width: '5%',
          align: "center"
        },
        {
          title: '图标',
          dataIndex: 'icon',
          width: '5%',
          align: "center",
          scopedSlots: {customRender: 'icon'},
        },
        {
          title: '标记',
          align: "center",
          width: '15%',
          dataIndex: 'authority',
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '15%',
          scopedSlots: {customRender: 'action'},
          align: "center",
        }
      ],
      url: {
        structList: window._CONFIG['domainURL'] + "/permission/structList",
        delete: window._CONFIG['domainURL'] + "/permission",
      }
    }
  },
  methods: {
    loadData() {
      let that = this;
      that.loading = true;
      const handleSuccess = (res) => {
        if (res) {
          that.data = res.data;
        }
      };
      this.$axios.get(this.url.structList, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
          .finally(() => {
            that.loading = false;
          });
    },

    handleAdd() {
      this.$refs.permissionCreateModal.add();
    },
    handleEdit(record) {
      this.$refs.permissionCreateModal.edit(record);
    },
    handleDelete(id) {
      let that = this;
      const handleSuccess = (res) => {
        if (res) {
          let response = res.data;
          if (response.code === 200) {
            that.$message.success(response.msg);
            that.loadData();
          } else {
            that.$message.error(response.msg);
          }
        }
      };
      that.$axios.delete(that.url.delete + "?id=" + id, {headers: that.headers})
          .then(handleSuccess)
          .catch((error) => that.catchError(error).then(handleSuccess))
    }
  },
  created() {
    this.loadData();
  }

}
</script>

<style scoped>

</style>
